// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1_HJn","imgContainer":"card-module--img-container--1mNMZ","contentContainer":"card-module--content-container--1XVw-","link":"card-module--link--2lNMI"};